import React from "react"

import close from "./../../../UI/general/close.svg"
import gallery from "./../../../UI/Modal/gallery.svg"
import collapsed from './../../../UI/general/collapse.svg'

import next from './../../../UI/general/Next-Asset.svg'

interface Props {
    galleryData: any,
    colorsData: any,
    isGallery: boolean,
    handleGalleriesSelection: any,
    handleCloseGalleryModal: any,
    breadCrumbSelected: number,
    handleChangeBreadCrumbSelected: any
}

interface State {
    isCollapsed: boolean
    rgbaColor: any,
    galleryItemSelected: string,
    galleryIndexSelected: number,
    breadCrumbs: any,
    show: boolean
}

declare const window: any;
class GalleryModal extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isCollapsed: true,
            rgbaColor: "",
            galleryItemSelected: "",
            galleryIndexSelected: -1,
            breadCrumbs: [],
            show: false
        }
    }

    componentDidMount(): void {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.props.colorsData.main_buttons)
        this.setState({
          rgbaColor: result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : ""
        })
        if(this.state.isCollapsed){
            setTimeout(() => {
                this.setState({
                    isCollapsed: false
                }, () => {
                    
                })
            },500)
        }
        setTimeout(() => {
            this.setState({
                show: true
            })
        }, 100)
        
      }

      componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if(prevProps.breadCrumbSelected !== this.props.breadCrumbSelected){
            if(this.props.breadCrumbSelected === -1){
                this.setState({
                    galleryItemSelected: "",
                    galleryIndexSelected: -1,
                    breadCrumbs: ['Galería']
                })
            }
            /*if(this.props.breadCrumbSelected === 0){
                this.setState({
                    galleryIndexSelected: -1,
                }, () => {
                    this.setState({
                        galleryIndexSelected: 0
                    })
                })
            }*/
        }
        if(prevProps.isGallery !== this.props.isGallery && this.props.isGallery){
            setTimeout(() => {
                this.setState({
                    isCollapsed: !this.props.isGallery
                })
            },300)
        }
        else if(prevProps.isGallery !== this.props.isGallery && this.props.isGallery !== false){
            this.setState({
                galleryItemSelected: "",
                galleryIndexSelected: -1,
                breadCrumbs: ['Galería']
            })
        }
      }
    
    render(): React.ReactNode {
        return(
            this.state.rgbaColor !== "" ?
            <div className={this.state.show ? "gallery-modal-container fade-in":"gallery-modal-container fade-out"}>
                <div className={this.state.isCollapsed ? "gallery-preview-expanded":"gallery-preview-collapsed"}>
                    {/*<div 
                        className="gallery-modal-close-btn" 
                        style={{backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons: ""}} 
                        onClick={() => {
                            this.setState({
                                galleryIndexSelected: -1,
                                galleryItemSelected: "",
                                breadCrumbs: []
                            })
                            this.props.handleCloseGalleryModal()
                        }}
                    >
                        <img src={close} alt=""/>
                    </div>*/}
                    <div className="gallery-preview-image-container">
                        <img src={gallery} alt="" className="gallery-preview-image"/>
                        <div className="gallery-preview-text">
                            Selecciona una opción en el panel para navegar en la galería
                        </div>
                    </div>
                </div>
                <div className={this.state.isCollapsed ? "gallery-media-container-wide":"gallery-media-container"}>
                    <div className="gallery-media-container-close">
                        
                    </div>
                </div>
                {
                    <div className={this.state.isCollapsed ? "collapsed-general-gallery-btn-collapsed":"collapsed-general-gallery-btn"} onClick={() => {this.setState({isCollapsed: !this.state.isCollapsed})}}>
                        <img src={collapsed} alt=""/>
                    </div>
                }
                {
                    this.props.isGallery ?
                    <div className={this.state.isCollapsed ? "gallery-general-sidebar-collapsed":"gallery-general-sidebar"}>
                        <div 
                        className="general-gallery-close-container"
                        onClick={() => {
                            this.setState({
                                galleryIndexSelected: -1,
                                galleryItemSelected: "",
                                breadCrumbs: [],
                                isCollapsed: true
                            })
                            setTimeout(() => {
                                this.setState({
                                    show: false
                                }, () => {
                                    setTimeout(() => {
                                        this.props.handleCloseGalleryModal()
                                    },500)
                                })
                            }, 500)
                            
                        }}
                        >
                            <img src={close} alt=''/>
                        </div>
                        <div className="general-gallery-img-icon-container">
                            <img src={gallery} alt=''/>
                        </div>
                        <div className="galerry-name-desktop" onClick={() => {this.setState({galleryIndexSelected: -1, galleryItemSelected: '', breadCrumbs: ['Galería']})}}>GALERÍA</div>
                        {
                            this.state.galleryIndexSelected !== -1 ?
                            <div className='breadcrumbs-gallery-container-desktop'>
                                {
                                    this.state.galleryItemSelected !== '' ?
                                    <div style={{display: 'flex'}} className="bread-crumbs-individual-container">
                                        <div className="deselected-bread-crumb-individual" onClick={() => {this.setState({galleryIndexSelected: -1, galleryItemSelected: '', breadCrumbs: ['Galería']})}}>{'Galería'}</div>
                                        <img src={next} alt=''/>
                                        <div className="selected-breadcrumb-individual" style={{backgroundColor: this.props.colorsData.main_buttons}}>{this.state.galleryItemSelected}</div>
                                    </div>:null
                                }
                            </div>:null
                        }
                        <div className="gallery-categories-container">
                            { this.state.galleryIndexSelected === -1 ?
                                this.props.galleryData.map((galleryCategory: any, index: number) =>
                                    <div 
                                    className="individual-gallery-container" 
                                    onClick={() => {
                                        this.setState({galleryItemSelected: galleryCategory.name,galleryIndexSelected: index})
                                        this.props.handleChangeBreadCrumbSelected(0)
                                    }}
                                    style={{
                                        pointerEvents: this.state.isCollapsed ? 'none':'all',
                                        animation: 'fadein ' + (index + 1.2)+'s ease-in-out 1'
                                    }}
                                    >
                                        <div className="indiividual-gallery-image">
                                            <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+galleryCategory.background} alt=""/>
                                        </div>
                                        <div 
                                        className="individual-gallery-name"
                                        style={{
                                            backgroundColor: `rgba(${this.state.rgbaColor.r},${this.state.rgbaColor.g},${this.state.rgbaColor.b}, 0.8)`
                                        }}
                                        >
                                            <div>{galleryCategory.name.toUpperCase()}</div>
                                        </div>
                                    </div>
                                ): null
                            }
                        </div>
                        {
                            this.state.galleryIndexSelected !== -1 ?
                            <div className="gallerie-modal-items-container">
                                {
                                    this.props.galleryData[this.state.galleryIndexSelected].galleries.galleries.map((galleries: any, index: number) => 
                                    galleries.map((gallery: any) => 
                                    <div className="gallerie-modal-items-individual" onClick={() => {
                                        this.setState({
                                            breadCrumbs: []
                                        }, () => {
                                            this.state.breadCrumbs.push(this.state.galleryItemSelected)
                                            this.state.breadCrumbs.push(gallery.name)
                                            this.props.handleGalleriesSelection(gallery, this.state.breadCrumbs, true)
                                        })
                                        }}>
                                        <img src={gallery.icon} alt=""/>
                                        <div className="gallerie-modal-name">{gallery.name}</div>
                                    </div>
                                    )

                                    )
                                }
                            </div>:null
                        }
                    </div>:null
                }
 
            </div>:null
        )
    }
}

export default GalleryModal